import { DeleteOutlined } from '@ant-design/icons';
import { Divider, Button } from 'antd';
import { useContext } from 'react';

import { ClientFiltersContext } from '@app/providers';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const ClientsClearButton: NClientsList.ClientsClearButton = ({
  includedFiltersIndex,
}) => {
  const { clearClientsGroup } = useContext(ClientFiltersContext);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        clearClientsGroup(includedFiltersIndex);
      }}
    >
      <Divider style={{ marginTop: '0px', marginBottom: '4px' }} />
      <Button
        className="clients-visits-clear-button"
        danger
        type="text"
        icon={<DeleteOutlined />}
      >
        Очистить
      </Button>
    </div>
  );
};
